export default {
    install(Vue, option) {
        Vue.prototype.$common = new (function () {
            const isDev = (window.location.hostname).includes('localhost') || (window.location.hostname).includes('innpressionhost') || (window.location.hostname).includes('uat');

            this.log = value => {
                if (isDev) {
                    console.log(value)
                }
            }

            this.error = value => {
                if (isDev) {
                    console.error(value)
                }
            }

            this.logData = (data, title = '') => {
                if (isDev) {
                    if (title !== '') {
                        console.log(`------------- ${title} -------------`);
                    }
                    console.log(JSON.parse(JSON.stringify(data)));
                }
            }

            this.duplicateData = data => {
                return JSON.parse(JSON.stringify(data));
            }

            this.diffQuery = (newQuery, oldQuery) => {
                Object.keys(newQuery).forEach(key => {
                    if (newQuery[key] === null ||
                        newQuery[key] === '' ||
                        key === 'searchType' && !newQuery['search']
                    ) {
                        delete newQuery[key];
                    }
                })

                if (Object.keys(newQuery).length !== Object.keys(oldQuery).length) {
                    return newQuery;
                }

                let diff = false;
                const keys = Object.keys(newQuery);
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    if (newQuery[key] != oldQuery[key]) {
                        diff = true;
                        break;
                    }
                }

                if (diff) {
                    return newQuery;
                } else {
                    return null;
                }
            }

            // ============ File Function =================
            this.getAcceptFileFormat = type => {
                if (type === 'video') {
                    return "video/mp4,video/webm"
                } else if (type === 'imgWithPDF') {
                    return ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/pjpeg,image/png,image/png,image/*;capture=camera"
                } else if (type === 'doc') {
                    return ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                }

                return ".jpg,.jpeg,.png,image/jpeg,image/pjpeg,image/png,image/png,image/*;capture=camera"; // default image
            }

            this.formatUploadProgress = (value, total) => {
                return ((value / total) * 100).toFixed(2)
            }


            // ============ Data Process Function =================
        })()
    }
}